import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import googleDocs from "../Assets/images/google-docs.svg";
import excelImg from "../Assets/images/excel.svg";
import { useNavigate } from "react-router-dom";
import { LanguageConstants } from "../constants/LanguageConstants";
import useMakeRequest from "../utils/ApiHelper";
import { ApiConstants } from "../constants/ApiConstants";
import { PAGINATION } from "../constants/Constants";
import { ensureBusinessProfileAllowsQuote } from "../utils/quoteAccessGate";

/** Same UI as legacy `RequestQuoteModal.tsx`; draft count from `/quotes/drafts/list` only (writable by non-root). */
function RequestQuoteModalImpl(prop: any) {
  const [type, setType] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const profile = useSelector((state: any) => state?.ProfileState?.data?.data);
  const draftList = useMakeRequest();

  useEffect(() => {
    draftList.makeRequest({
      payload: {
        search: "",
        page: PAGINATION.PAGE,
        pageSize: 25,
        orderDirection: "DESC",
      },
      url: ApiConstants?.QuotesDraftList,
      toastStatus: false,
    });
  }, []);

  const inner = draftList?.data?.data;
  const serverDraftCount = Number(
    (inner && typeof inner.count !== "undefined" ? inner.count : null) ??
      draftList?.data?.count ??
      (Array.isArray(inner?.rows) ? inner.rows.length : 0) ??
      0
  );
  const totalDraftCount = serverDraftCount;
  /** Drafts only for manual entry; hidden when Bulk Upload is selected (SS1). */
  const showDraftsButton = totalDraftCount > 0 && type === "create-request-quote";

  useEffect(() => {
    if (totalDraftCount === 0 && !type) {
      setType("create-request-quote");
    }
  }, [totalDraftCount, type]);

  const handleClose = () => {
    prop.handelClso();
    navigate("/", { state: { data: { modelShow: false } } });
  };

  const handleDrafts = () => {
    prop.handelClso();
    navigate("/drafts");
  };

  const handleSelect = () => {
    if (!type) {
      setError(LanguageConstants?.PLEASE_SELECT_TYPE);
      return false;
    }
    if (!ensureBusinessProfileAllowsQuote(profile, navigate, LanguageConstants as any)) {
      return false;
    }
    setError("");
    if (type === "select-excel-address") {
      try {
        window.sessionStorage.removeItem("qnBulkWizardStateV1");
      } catch {
        /* fresh bulk request from modal */
      }
    }
    navigate(`/${type}`);
    prop.handelClso();
    return true;
  };

  return (
    <>
      <div
        className="modal fade rqst-quote-modal show"
        id="requestQuoteModal"
        aria-labelledby="requestQuoteModalLabel"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header rqst-quote-modal__header justify-content-center">
              <div>
                <h5 className="modal-title w-100" id="requestQuoteModalLabel">
                  {LanguageConstants?.NEW_REQUEST_QUOTES}
                </h5>
                <p className="rqst-quote-modal__subtitle">{LanguageConstants?.SELECT_METHOD}</p>
              </div>
              <button type="button" onClick={handleClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body pb-0 text-start">
              <div className="rqst-quote-modal__options">
                <div
                  className="rqst-btn-btn form-check"
                  onClick={() => {
                    setType("create-request-quote");
                    setError("");
                  }}
                >
                  <input
                    className="form-check-input form-check-radio"
                    type="radio"
                    name="requestQuote"
                    id="requestQuote-1"
                    checked={type === "create-request-quote"}
                    readOnly
                  />
                  <label htmlFor="requestQuote-1">
                    <img src={googleDocs} alt="" />
                    <span className="rqst-btn-btn__content">
                      <strong>{LanguageConstants?.QUOTATIONFORM}</strong>
                      <small>{LanguageConstants?.QUOTATIONFORM_DESC}</small>
                    </span>
                    <span className={`rqst-btn-btn__radio${type === "create-request-quote" ? " is-active" : ""}`} aria-hidden>
                      <i />
                    </span>
                  </label>
                </div>
                <div
                  className="rqst-btn-btn form-check"
                  onClick={() => {
                    setType("select-excel-address");
                    setError("");
                  }}
                >
                  <input
                    className="form-check-input form-check-radio"
                    type="radio"
                    name="requestQuote"
                    id="requestQuote-2"
                    checked={type === "select-excel-address"}
                    readOnly
                  />
                  <label htmlFor="requestQuote-2">
                    <img src={excelImg} alt="" />
                    <span className="rqst-btn-btn__content">
                      <strong>{LanguageConstants?.EXCEL}</strong>
                      <small>{LanguageConstants?.EXCEL_DESC}</small>
                    </span>
                    <span className={`rqst-btn-btn__radio${type === "select-excel-address" ? " is-active" : ""}`} aria-hidden>
                      <i />
                    </span>
                  </label>
                </div>
              </div>
              {error && <p className="rqst-quote-modal__error">{error}</p>}
            </div>
            <div
              className={`modal-footer rqst-quote-modal__footer mt-4${showDraftsButton ? "" : " rqst-quote-modal__footer--single"}`}
            >
              {showDraftsButton ? (
                <button type="button" className="round-btn m-0 rqst-quote-modal__action" onClick={handleDrafts}>
                  {LanguageConstants?.DRAFTS} {totalDraftCount}
                </button>
              ) : null}
              <button
                type="button"
                className="round-btn m-0 rqst-quote-modal__action"
                onClick={handleSelect}
              >
                {LanguageConstants?.COUNTINUE}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RequestQuoteModalImpl;
